module.exports = __webpack_public_path__ + "img/5.63ef52a4.jpg";